import React from "react";

export interface NodeReadingData {
  nodeId: string;
  nodeName: string;
  paremeterId: string;
  serialNumberSource: string;
  readings?: { [timestamp: string]: { v: number; s?: string; q?: number | null } };
  valueUnit: string;
  infrastructureName: string;
  error?: string;
}

export interface RealtimeDataContextType {
  realtimeEnabled: boolean;
  currentTime: string | null;
  nodeReadings: NodeReadingData[];
  getNodeValue: (nodeId: string) => number | null;
}

const initialContext: RealtimeDataContextType = {
  realtimeEnabled: false,
  currentTime: null,
  nodeReadings: [],
  getNodeValue: () => null,
};

const RealtimeDataContext = React.createContext<RealtimeDataContextType>(initialContext);

export default RealtimeDataContext;